











import { Component, Vue } from 'vue-property-decorator';

import Container from '@/components/layout/Container.vue';
import SectionCard from '@/components/homescapes/hs001v1/SectionCard.vue';
import PlayButton from '@/components/PlayButton.vue';
import ThumbGallerySlides from '@/components/homescapes/hs001v1/ThumbGallerySlides.vue';

import { addGtmEvent, GTMEvent } from '@/helpers/gtm';

import * as SLIDES from '@/config/slides';

@Component({
  components: { Container, SectionCard, PlayButton, ThumbGallerySlides },
})
export default class PreviewSection extends Vue {
  get slides(): Slides {
    return SLIDES as Slides;
  }

  get localeSlides() {
    const { locale } = this.$i18n;

    const { en: defaultSlides } = this.slides;

    return this.slides[locale] || defaultSlides;
  }

  handlePlayClick() {
    addGtmEvent(GTMEvent.LANDING_CLICK);
  }
}
